import styled from 'styled-components';
import { media } from 'utils/detection';

export default styled.video`
  width: 100%;
  object-fit: cover;

`;
